import * as angular from 'angular';

"use strict";

angular.module('SocketsModule', []);

export default 'SocketsModule';